module.exports = __webpack_public_path__ + "static/media/gcdef_106.b9fbd64c.ico";